import { Title, Text, Container } from '@mantine/core';
import style from './descriptionCompoStyle.module.css';
import '../../../index.css';
const DescHouseDetailCompo = (props) => {
  return (
    <div className={style.pelindung}>
      <Container>
        <Title
          mt={20}
          size={20}
          color="#F56600"
          style={{ fontFamily: 'Nunito, sans-serif', fontWeight: 700 }}
        >
          Deskripsi
        </Title>
        <Text
          mt={20}
          align="justify"
          style={{ fontFamily: 'Nunito Sans, sans-serif' }}
        >
          {props.description1}
        </Text>
        {/* <Text mt={20} align="justify">
          {props.description2}
        </Text> */}
      </Container>
    </div>
  );
};

export default DescHouseDetailCompo;
